import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "baseLayout" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("header", null, [
            _renderSlot(_ctx.$slots, "header")
        ]),
        _createElementVNode("body", null, [
            _renderSlot(_ctx.$slots, "body")
        ]),
        _createElementVNode("footer", null, [
            _renderSlot(_ctx.$slots, "footer")
        ])
    ]));
}
